export class appResponse {

  private openAMToken: string;
  private webToken: string;
  private openIDMSession: string;
  private userName: string;
  private customers: Array<string>;

  constructor(openAMToken: string,webToken: string,openIDMSession: string,userName: string,customers: Array<string>) {
      this.openAMToken = openAMToken;
      this.webToken = webToken;
      this.openIDMSession = openIDMSession;
      this.userName = userName;
      this.customers = customers;
  }
}
